import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import {
  CustomizedButton,
  CustomizedDialog,
  CustomizedTypography
} from '@components/Customized';

interface ServiceSurveyCompleteDialogProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles((theme) => {
  return {
    typography: {
      textAlign: 'center',
      ...theme.typography.body1,
      fontWeight: 400,
      marginTop: 32,
      marginBottom: 32
    },
    button: {
      height: 48
    }
  };
});
const CheckCircleOutlinedIcon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="21"
        cy="21"
        r="20"
        stroke="#3479FF"
        style={{ strokeWidth: 2 }}
      />
      <path
        d="M17.4944 25.2383L12.9335 20.6773L11.3804 22.2195L17.4944 28.3336L30.6194 15.2086L29.0772 13.6664L17.4944 25.2383Z"
        fill="#3479FF"
      />
    </svg>
  );
};

const ServiceSurveyCompleteDialog = (
  props: ServiceSurveyCompleteDialogProps
) => {
  const classes = useStyles();
  return (
    <CustomizedDialog
      onClose={props.onClose}
      open={props.open}
      title={
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <CheckCircleOutlinedIcon />

          <CustomizedTypography
            fontWeight="700"
            color="primary"
            variant="h4"
            style={{ marginTop: 8 }}
          >
            소중한 의견 감사합니다
          </CustomizedTypography>
        </Grid>
      }
    >
      <Grid container justifyContent="center" alignItems="center">
        <CustomizedTypography className={classes.typography}>
          제출해주신 서비스를 내부에서 검토하여
          <br />
          &nbsp; 빠른 시일 내에 준비하도록 하겠습니다.
        </CustomizedTypography>
      </Grid>

      <Grid container>
        <CustomizedButton
          className={classes.button}
          fullWidth
          color="primary"
          variant="contained"
          onClick={props.onClose}
        >
          닫기
        </CustomizedButton>
      </Grid>
    </CustomizedDialog>
  );
};

export default ServiceSurveyCompleteDialog;
